import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { IncludeExcludeOnlyRadioGroup } from '../../components/search-filters-radio-group/include-exclude-only-radio-group'

export const WriteOff = withFacetContext(
    FacetName.is_writeoff,
    withFilterContext(FilterName.is_writeoff, IncludeExcludeOnlyRadioGroup, {
        title: 'CAT S/C/D/N',
        placeholder: 'Include Cat S/C/D/N',
    })
)
